var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafepal670D16F0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1B1A1F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "logo2",
    className: "st0",
    d: "M21.6,14.2v4h-4.3v16.7l-1.1-0.4c-0.5-0.2-1.4-0.5-2.4-1l-0.5-0.2v-32L17.5,0l4.1,1.3v4.4l-4.1-1.3 l-0.3,0.1v9.8H21.6z M2.4,18.3V4.7l9.6-3v4.3L6.4,7.8v6.5h5.5v18.7l-1.2-0.6c-3.8-2-8.3-5.3-8.3-9.9v-2.2h4v2.2c0,1,0.5,2,1.5,3 v-7.1H2.4z M22.8,1.6l9.8,3v13.6h-5.8v5.9c0,0-1.3,1.7-4,3.1C22.8,26.2,22.8,1.6,22.8,1.6z M28.6,14.2V7.8l-1.7-0.5v7H28.6z  M28.6,22.7v-2.5h4v2.5c0,6.9-10,10.8-13,11.9L18.5,35v-4.3l0.5-0.2C23.8,28.7,28.6,25.6,28.6,22.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafepal670D16F0);
export default __webpack_public_path__ + "static/media/safepal.670d16f0.670d16f0abadc95c9704375763de1f40.svg";
export { ForwardRef as ReactComponent };